import React from 'react';
import { Tab, Tabs } from '@mui/material';
import BadgeIcon from '@mui/icons-material/Badge';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import RepeatIcon from '@mui/icons-material/Repeat';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { useUser } from '../../../contexts/user.context';
import { PLATFORMS } from '../../../utils/constants';
import { isBilledByTrayCompatiblePlatform } from '../../../utils/subscriptions';

export default function AccountTabs({ selectedTab, setSelectedTab }) {
    const { user } = useUser();

    const isBilledByTray = isBilledByTrayCompatiblePlatform(user?.subscription);
    const isWix = user?.store?.platformId === PLATFORMS.WIX;

    const tabStyle = {
        color: 'black',
        fontFamily: 'Cabin, sans-serif',
        textTransform: 'none'
    }

    return (
        <Tabs
            value={selectedTab}
            onChange={(e, value) => setSelectedTab(value)}
        >
            <Tab icon={<BadgeIcon />} iconPosition="start" label="Geral" sx={tabStyle} />
            <Tab
                icon={<IntegrationInstructionsIcon />}
                iconPosition="start"
                label="Contas de desenvolvedor"
                sx={tabStyle}
            />
            <Tab icon={<RepeatIcon />} iconPosition="start" label="Assinatura" sx={tabStyle} />
            {isBilledByTray || isWix ? <></> : (
                <Tab icon={<ReceiptIcon />} iconPosition="start" label="Faturas" sx={tabStyle} />
            )}
        </Tabs>
    );
}